module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container mb-5"
  }, [(_vm.quiz === null) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : (_vm.quiz.failed) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-6 offset-md-3 mt-5 text-center"
  }, [_c('b-alert', {
    attrs: {
      "variant": 'danger',
      "show": ""
    }
  }, [_vm._v("Laden des Quizzes fehlgeschlagen.")])], 1)]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 mt-3"
  }, [_c('h4', {
    staticClass: "pt-3",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.quiz.name))]), _vm._v(" "), _c('ul', {
    staticClass: "list-inline nav-pills text-center",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: [_vm.activeTab == -1 ? 'active' : ''],
    attrs: {
      "href": "#",
      "id": "startnav"
    },
    on: {
      "click": function($event) {
        _vm.openTab(-1)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tStart\n\t\t\t\t\t")])]), _vm._v(" "), _vm._l((_vm.quiz.questions), function(question, key) {
    return _c('li', {
      key: key + 'nav',
      staticClass: "list-inline-item",
      attrs: {
        "id": key + 'nav'
      }
    }, [_c('a', {
      staticClass: "nav-link",
      class: {
        'active': _vm.activeTab == key
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.openTab(key)
        }
      }
    }, [(_vm.quiz.questions.length < 10) ? _c('span', [_vm._v(_vm._s((key + 1) + '. Frage'))]) : _c('span', [_vm._v(_vm._s(key + 1))]), _vm._v(" "), (question.answered) ? _c('i', {
      staticClass: "fa fa-check fa-fw"
    }) : _vm._e()])])
  }), _vm._v(" "), (_vm.quizSolved) ? _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      'active': _vm.activeTab == _vm.quiz.questions.length
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.openTab(_vm.quiz.questions.length)
      }
    }
  }, [_vm._v("Rangliste")])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 offset-md-3 mt-3 mb-4"
  }, [_c('b-progress', {
    staticStyle: {
      "height": "5px"
    },
    attrs: {
      "value": _vm.progress,
      "variant": 'success'
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-8 offset-lg-2",
    attrs: {
      "id": "question-holder"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    },
    on: {
      "before-leave": _vm.beforeLeave,
      "after-leave": _vm.afterLeave,
      "enter": _vm.enter
    }
  }, [(_vm.activeTab == -1) ? _c('div', {
    key: 'starttab',
    staticClass: "tab-pane active",
    attrs: {
      "id": "starttab"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12",
    domProps: {
      "innerHTML": _vm._s(_vm.nl2br(_vm.quiz.description))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [(!_vm.local) ? _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8001728079841345",
      "ad-slot": "8970086511",
      "ad-style": "display: block",
      "ad-format": "auto"
    }
  }) : _c('p', {
    staticClass: "text-center text-muted"
  }, [_vm._v("Werbung")])], 1), _vm._v(" "), _c('div', {
    staticClass: "w-100"
  }, [_c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "col text-center"
  }, [(_vm.progress < 100) ? _c('timer', {
    attrs: {
      "time": _vm.quiz.startTime
    }
  }) : _c('div', [_c('i', {
    staticClass: "fa fa-clock-o fa-fw text-info"
  }), _vm._v(" " + _vm._s(_vm._f("makeDurationPretty")(_vm.quiz.endTime - _vm.quiz.startTime)))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col text-center"
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o fa-fw"
  }), _vm._v(" " + _vm._s(_vm.progress) + "%")]), _vm._v(" "), _c('div', {
    staticClass: "w-100 hidden-sm-up"
  }, [_c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "col text-center"
  }, [(_vm.progress < 100) ? _c('b-button', {
    attrs: {
      "size": 'sm',
      "variant": 'link'
    },
    on: {
      "click": _vm.startQuiz
    }
  }, [(_vm.quiz.restart) ? _c('i', {
    staticClass: "fa fa-spin fa-spinner fa-fw"
  }) : _vm._e(), _vm._v(" Neustart")]) : _c('b-button', {
    attrs: {
      "size": 'sm',
      "variant": 'warning'
    },
    on: {
      "click": _vm.startQuiz
    }
  }, [(_vm.quiz.restart) ? _c('i', {
    staticClass: "fa fa-spin fa-spinner fa-fw"
  }) : _vm._e(), _vm._v(" erneut starten")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 row"
  }, [_c('div', {
    staticClass: "col"
  }, [(_vm.quizSolved) ? _c('b-button', {
    attrs: {
      "size": 'sm',
      "variant": 'primary'
    },
    on: {
      "click": function($event) {
        _vm.openTab(_vm.quiz.questions.length)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-line-chart fa-fw"
  }), _vm._v(" Rangliste")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": 'sm',
      "variant": _vm.quizSolved ? 'secondary' : 'success'
    },
    on: {
      "click": _vm.nextTab
    }
  }, [_vm._v("1. Frage "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])], 1)])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.quiz.questions), function(question, key) {
    return (_vm.activeTab == key) ? _c('div', {
      key: key + 'tab',
      staticClass: "tab-pane active",
      attrs: {
        "id": key + 'tab'
      }
    }, [_c('question-' + question.type, {
      tag: "div",
      attrs: {
        "question": question,
        "questionKey": key
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "mt-3 row"
    }, [_c('div', {
      staticClass: "col"
    }, [(_vm.activeTab > -1) ? _c('b-button', {
      attrs: {
        "size": 'sm'
      },
      on: {
        "click": _vm.lastTab
      }
    }, [_c('i', {
      staticClass: "fa fa-arrow-left"
    }), _vm._v(" " + _vm._s(key == 0 ? 'Start' : key + '. Frage'))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "col text-center"
    }, [(_vm.quizSolved) ? _c('b-button', {
      attrs: {
        "size": 'sm',
        "variant": 'primary'
      },
      on: {
        "click": function($event) {
          _vm.openTab(_vm.quiz.questions.length)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-line-chart fa-fw"
    }), _vm._v(" Rangliste")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "col"
    }, [(_vm.activeTab < _vm.quiz.questions.length - 1) ? _c('b-button', {
      staticClass: "pull-right",
      attrs: {
        "size": 'sm',
        "variant": question.answered ? 'success' : 'secondary'
      },
      on: {
        "click": _vm.nextTab
      }
    }, [_vm._v(_vm._s(key + 2) + ". Frage "), _c('i', {
      staticClass: "fa fa-arrow-right"
    })]) : _vm._e()], 1)])]) : _vm._e()
  }), _vm._v(" "), (_vm.quizSolved && _vm.activeTab == _vm.quiz.questions.length) ? _c('div', {
    staticClass: "tab-pane active"
  }, [_c('b-card', [_c('div', [_c('b-button', {
    attrs: {
      "size": 'sm'
    },
    on: {
      "click": _vm.lastTab
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-fw"
  }), _vm._v(" " + _vm._s(_vm.quiz.questions.length) + ". Frage")]), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": 'sm'
    },
    on: {
      "click": function($event) {
        _vm.openTab(-1)
      }
    }
  }, [_vm._v("Start")])], 1), _vm._v(" "), (_vm.userRang.length > 0) ? _c('h5', {
    staticClass: "text-center mt-5 mt-sm-0"
  }, [_vm._v("Du hast den " + _vm._s(_vm.userRang[0].rang) + ". Platz erreicht.")]) : _c('h6', {
    staticClass: "text-center text-muted mt-5 mt-sm-0"
  }, [_vm._v("Keine Ranglisteneinträge von dir vorhanden.")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [(!_vm.local) ? _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8001728079841345",
      "ad-slot": "9735469318",
      "ad-style": "display: block",
      "ad-format": "auto"
    }
  }) : _c('p', {
    staticClass: "text-center text-muted"
  }, [_vm._v("Werbung")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block mt-4"
  }, [_c('transition-group', {
    staticClass: "list-unstyled",
    attrs: {
      "name": "hallOfFame",
      "tag": "ul"
    }
  }, _vm._l((_vm.hallOfFame), function(fame, key) {
    return _c('dl', {
      key: fame,
      staticClass: "row"
    }, [_c('dt', {
      staticClass: "col-sm-3"
    }, [_c('span', {
      staticClass: "badge badge-pill badge-info"
    }, [_vm._v(_vm._s(key + 1) + ".")]), _vm._v("  " + _vm._s(_vm._f("makeDurationPretty")(fame.duration))), _c('i', {
      staticClass: "fa fa-clock-o fa-fw"
    })]), _vm._v(" "), (fame.userid == _vm.$store.state.user.uid) ? _c('dd', {
      staticClass: "col-sm-9"
    }, [_c('mark', {
      on: {
        "click": function($event) {
          _vm.deleteFame(fame.key)
        }
      }
    }, [_vm._v(_vm._s(fame.username ? fame.username : 'Anonym'))])]) : (fame.username) ? _c('dd', {
      staticClass: "col-sm-9"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(fame.username) + "\n\t\t\t\t\t\t\t\t\t")]) : _c('dd', {
      staticClass: "col-sm-9"
    }, [_c('span', {
      on: {
        "click": function($event) {
          _vm.deleteFame(fame.key)
        }
      }
    }, [_vm._v("Anonym")])])])
  }))], 1)])], 1) : _vm._e()], 2)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 text-center"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner fa-3x fa-fw text-muted mt-5"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b3c1aa54"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/router/Quiz.vue
// module id = 714
// module chunks = 1